import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import "./Styles.css";
import "./StylesMedia.css";
import Home from './Home';
import Play from './Play';
import Events from './events/Events';

function App() {
    useEffect(() => {
        const handleFocusIn = () => {
            document.body.style.setProperty("zoom", "1");
        };

        document.addEventListener("focusin", handleFocusIn);

        return () => {
            document.removeEventListener("focusin", handleFocusIn);
        };
    }, []);

    return (
        <div className="App">
            <Routes>
                <Route path='/' element={<Home />} />
                <Route path='/play' element={<Play />} />
                <Route path='/events' element={<Events />} />
            </Routes>
        </div>
    );
}

export default App;
